import { template } from "underscore";

/**
 * Wrapper function to contain all usages of Underscore Template to make
 * @deprecated TODO: Replace with something like Handlebars or Eta.js.
 */
export function underscoreTemplateGrindex(templateString: string, settings?: _.TemplateSettings): ReturnType<typeof template> {
	const result = template(templateString, settings);
	return result;
}
